
var App = App || {};

App.Carousel = (function ($) {
    "use strict";

    function init() {
        const carousels = $(".block.block-carousel");
        if (!carousels.length) return;

        carousels.each(function () {
            InitCarousel($(this));
        });
    }

    function InitCarousel(carouselBlock) {
        const splideRoot = carouselBlock.find(".splide")[0];
        if (!splideRoot) return;

        const splideCarousel = new Splide(splideRoot, {
            type: "loop",
            autoplay: true,
            interval: 5000,
            pauseOnHover: false,
            autoHeight:true,
            arrows: true,
            pagination: true,
        });

        splideCarousel.mount();

        const $playPause = carouselBlock.find(".carousel-controls .play-pause");
        let isPlaying = !!splideCarousel.options.autoplay;

        if ($playPause.length) {
            $playPause.html(isPlaying ? '<i class="fas fa-pause" aria-hidden="true"></i>'
                : '<i class="fas fa-play" aria-hidden="true"></i>');
            $playPause.attr("aria-label", isPlaying ? "Pause slideshow" : "Play slideshow");

            $playPause.on("click", function (e) {
                e.preventDefault();
                const Autoplay = splideCarousel.Components && splideCarousel.Components.Autoplay;

                if (!Autoplay) return;

                if (isPlaying) {
                    Autoplay.pause();
                    $(this).html('<i class="fas fa-play" aria-hidden="true"></i>');
                    $(this).attr("aria-label", "Play slideshow");
                } else {
                    Autoplay.play();
                    $(this).html('<i class="fas fa-pause" aria-hidden="true"></i>');
                    $(this).attr("aria-label", "Pause slideshow");
                }
                isPlaying = !isPlaying;
            });
        }

        const slidesCount = splideCarousel.length || carouselBlock.find(".splide__slide").length;
        if (slidesCount <= 1) {
            carouselBlock.find(".splide__arrows, .splide__pagination, .carousel-controls").hide();
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Carousel.init();
});
